const data = {
    "dati-fattura": {
      label: "Dati fattura",
      description: "Questi dati indicano il numero della fattura e il giorno in cui è stata emessa. Possono esserti utili quando hai bisogno di assistenza.",
      labelKeywords: ["dati", "dato", "fattura"],
      contentKeywords: ["dati", "dato", "fattura"],
      img: "./images/01-testata-04-datibolletta-01-datifattura.jpg",
      imgDescription: "Immagine che raffiugra la prima pagina della bolletta, con evidenziati i campi fornitura e numero fattura."
    },

    "periodo": {
      label: "Periodo di riferimento",
      description: "È il mese o bimestre a cui normalmente si riferisce la bolletta.",
      labelKeywords: ["periodo", "periodi", "riferimento", "periodo di riferimento"],
      contentKeywords: ["periodo", "periodi", "riferimento", "periodo di riferimento"],
      img: "./images/01-testata-04-datibolletta-02-periodo.jpg",
      imgDescription: "Immagine che raffigura la prima pagina della bolletta, con evidenziato il campo periodo di riferimento."
    }
}

export default data;